var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecuruty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.2975 1.34987C9.21141 1.28564 9.10712 1.25098 9 1.25098C8.89288 1.25098 8.78859 1.28564 8.7025 1.34987L1.25 6.92254V8.68604H2.25V16.2439C2.25 16.3775 2.30268 16.5057 2.39645 16.6002C2.49021 16.6947 2.61739 16.7478 2.75 16.7478H15.25C15.3826 16.7478 15.5098 16.6947 15.6036 16.6002C15.6973 16.5057 15.75 16.3775 15.75 16.2439V8.68604H16.75V6.92254L9.2975 1.34987Z",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 11.8657V12.4653C8.25 12.6657 8.32902 12.8579 8.46967 12.9997C8.61032 13.1414 8.80109 13.221 9 13.221C9.19891 13.221 9.38968 13.1414 9.53033 12.9997C9.67098 12.8579 9.75 12.6657 9.75 12.4653V11.8657C9.87729 11.7202 9.96023 11.5408 9.98887 11.3491C10.0175 11.1573 9.99062 10.9613 9.91144 10.7845C9.83226 10.6078 9.70415 10.4578 9.54248 10.3526C9.38081 10.2474 9.19245 10.1914 9 10.1914C8.80755 10.1914 8.61919 10.2474 8.45752 10.3526C8.29585 10.4578 8.16774 10.6078 8.08856 10.7845C8.00938 10.9613 7.9825 11.1573 8.01113 11.3491C8.03977 11.5408 8.12271 11.7202 8.25 11.8657Z",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8.68621V7.42656C7 6.89204 7.21071 6.37941 7.58579 6.00144C7.96086 5.62347 8.46957 5.41113 9 5.41113V5.41113C9.53043 5.41113 10.0391 5.62347 10.4142 6.00144C10.7893 6.37941 11 6.89204 11 7.42656V8.68621",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 8.68652H12.25V14.3045C12.25 14.3608 12.239 14.4165 12.2176 14.4684C12.1963 14.5204 12.165 14.5676 12.1255 14.6074C12.0861 14.6471 12.0392 14.6787 11.9876 14.7002C11.9361 14.7217 11.8808 14.7328 11.825 14.7328H6.175C6.11919 14.7328 6.06392 14.7217 6.01236 14.7002C5.9608 14.6787 5.91394 14.6471 5.87448 14.6074C5.83501 14.5676 5.80371 14.5204 5.78235 14.4684C5.76099 14.4165 5.75 14.3608 5.75 14.3045V8.68652Z",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecuruty);
export default __webpack_public_path__ + "static/media/securuty.aa5c281a.svg";
export { ForwardRef as ReactComponent };